export function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Reader mode is no longer forced by viewport width: phones get the scene as a
 * single-page tier instead (see scene/tier.js). It remains the automatic choice
 * for reduced-motion users and stays reachable through the mode toggle, which
 * is kept visible on touch tiers.
 */
export function shouldUseReaderMode() {
  return prefersReducedMotion();
}

export function bindKeyboardNavigation({ onPrevious, onNext, enabled }) {
  function onKeydown(event) {
    if (!enabled()) return;
    const activeTag = document.activeElement?.tagName?.toLowerCase();
    if (['input', 'textarea', 'select'].includes(activeTag)) return;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      onPrevious();
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      onNext();
    }
  }

  document.addEventListener('keydown', onKeydown);
  return () => document.removeEventListener('keydown', onKeydown);
}
